import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { integrationCategoriesApi, integrationCompaniesApi } from '../../services/webApi';

const Entegrasyonlar = () => {
  const [activeCategory, setActiveCategory] = useState(0);
  const [categories, setCategories] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    // Initialize AOS
    const initAOS = () => {
      if (window.AOS) {
        window.AOS.init();
      }
    };

    // Initialize Lucide Icons - Manuel yaklaşım
    const initLucide = () => {
      const createIcons = () => {
        if (window.lucide && window.lucide.createIcons) {
          console.log('Creating Lucide icons manually...');
          try {
            window.lucide.createIcons();
            console.log('Icons created successfully');
          } catch (error) {
            console.error('Error creating icons:', error);
          }
        } else {
          console.log('Lucide not ready, retrying...');
          setTimeout(createIcons, 200);
        }
      };
      
      createIcons();
    };

    // Fetch data from API
    const fetchData = async () => {
      try {
        // Categories'i önce çek
        const categoriesResponse = await integrationCategoriesApi.getAll();
        if (isMounted && categoriesResponse.data.success) {
          setCategories(categoriesResponse.data.data);
        } else if (isMounted) {
          console.log('Categories API failed, using fallback');
        }

        // Sonra companies'i çek
        const companiesResponse = await integrationCompaniesApi.getAll();
        if (isMounted && companiesResponse.data.success) {
          setCompanies(companiesResponse.data.data);
        } else if (isMounted) {
          console.log('Companies API failed, using fallback');
        }

        // Eğer her ikisi de başarısızsa fallback data kullan
        if (isMounted && (!categoriesResponse.data.success || !companiesResponse.data.success)) {
          console.log('Using fallback data');
          setCategories([
            {
              id: 1,
              title: 'SMS',
              description: 'SMS Entegrasyonları',
              icon: 'message-square'
            },
            {
              id: 2,
              title: 'Sanal Pos',
              description: 'Online ödeme sistemleri ile güvenli ödeme alın.',
              icon: 'credit-card'
            },
            {
              id: 3,
              title: 'E-Fatura / E-Arşiv',
              description: 'Elektronik fatura ve arşivleme sistemleri.',
              icon: 'file-text'
            },
            {
              id: 4,
              title: 'Kurum Ödemeleri',
              description: 'Kurumsal ödeme ve tahsilat sistemleri.',
              icon: 'building'
            },
            {
              id: 5,
              title: 'Muhasebe',
              description: 'Muhasebe yazılımları ile entegrasyon.',
              icon: 'calculator'
            }
          ]);
          setCompanies([
            { category_id: 1, name: 'Sanal Santral', logo: '/web-theme/images/logo/sanalsantral.jpg' },
            { category_id: 1, name: 'Netgsm', logo: '/web-theme/images/logo/netgsm.svg' },
            { category_id: 1, name: 'Verimor', logo: '/web-theme/images/logo/verimor.jpg' },
            { category_id: 1, name: 'Öztek SMS', logo: '/web-theme/images/logo/ozteksms.png' },
            { category_id: 1, name: 'E Telekom', logo: '/web-theme/images/logo/etelekom.png' },
            { category_id: 2, name: 'N Kolay', logo: '/web-theme/images/logo/nkolay.svg' },
            { category_id: 2, name: 'Türkiye İş Bankası A.Ş.', logo: '/web-theme/images/logo/isbank.png' },
            { category_id: 2, name: 'Türkiye Vakıflar Bankası T.A.O.', logo: '/web-theme/images/logo/vakifbank.svg' },
            { category_id: 2, name: 'Paytr', logo: '/web-theme/images/logo/paytr.webp' },
            { category_id: 3, name: 'Hızlı Bilişim Teknolojileri', logo: '/web-theme/images/logo/hizlibilisim.png' },
            { category_id: 3, name: 'QNB eSolutions', logo: '/web-theme/images/logo/qnb-esolutions.png' },
            { category_id: 4, name: 'Vakıfbank', logo: '/web-theme/images/logo/vakifbank.svg' },
            { category_id: 4, name: 'Garanti Bankası', logo: '/web-theme/images/logo/garanti.svg' },
            { category_id: 4, name: 'Türkiye İş Bankası', logo: '/web-theme/images/logo/isbank.png' },
            { category_id: 4, name: 'Teb Bankası', logo: '/web-theme/images/logo/teb.svg' },
            { category_id: 4, name: 'Aktif Bank', logo: '/web-theme/images/logo/aktifbank.svg' },
            { category_id: 4, name: 'nKolay', logo: '/web-theme/images/logo/nkolay.svg' },
            { category_id: 4, name: 'Türkiye Cumhuriyeti Ziraat Bankası A.Ş.', logo: '/web-theme/images/logo/ziraat-bankasi.png' },
            { category_id: 4, name: 'Faturakom', logo: '/web-theme/images/logo/faturakom.png' },
            { category_id: 4, name: 'Faturamatik', logo: '/web-theme/images/logo/faturamatik.png' },
            { category_id: 4, name: 'Enpara.com', logo: '/web-theme/images/logo/enpara.svg' },
            { category_id: 4, name: 'Finans Bank A.Ş.', logo: '/web-theme/images/logo/qnb.png' },
            { category_id: 4, name: 'Akbank T.A.Ş.', logo: '/web-theme/images/logo/akbank.svg' },
            { category_id: 4, name: 'Kuveyt Türk Katılım Bankası A.Ş.', logo: '/web-theme/images/logo/kuveytturk.svg' },
            { category_id: 4, name: 'Türkiye Finans Katılım Bankası A.Ş.', logo: '/web-theme/images/logo/turkiye-finans.png' },
            { category_id: 4, name: 'Yapı ve Kredi Bankası A.Ş.', logo: '/web-theme/images/logo/yapikredi.svg' },
            { category_id: 4, name: 'Türkiye Halk Bankası A.Ş.', logo: '/web-theme/images/logo/halkbank.svg' },
            { category_id: 4, name: 'Denizbank A.Ş.', logo: '/web-theme/images/logo/denizbank.svg' },
            { category_id: 5, name: 'Paraşüt', logo: '/web-theme/images/logo/parasut.png' },
            { category_id: 5, name: 'Mikro Yazılım', logo: '/web-theme/images/logo/mikro-yazilim.png' },
            { category_id: 5, name: 'BAY.t Yazılım', logo: '/web-theme/images/logo/bayt.webp' }
          ]);
        }
      } catch (err) {
        console.error('Integration data fetch error:', err);
        if (isMounted) {
          setError('Veriler yüklenirken hata oluştu');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // Hemen başlat
    initAOS();
    fetchData();
    
    // İkonları biraz sonra oluştur
    setTimeout(() => {
      initLucide();
    }, 1000);

    return () => {
      isMounted = false;
    };
  }, []);

  // Get companies for active category
  const getCompaniesForCategory = (categoryId) => {
    return companies.filter(company => company.category_id === categoryId);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-white">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    console.log('Error:', error);
  }


  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">Entegrasyonlar</span>
                    <br />Güçlü Sistem Entegrasyonları
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    ISP Radius, mevcut sistemlerinizle sorunsuz çalışacak şekilde tasarlanmıştır. Çeşitli entegrasyon seçenekleri ile iş akışınızı optimize edin.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Integration Categories - Tabs Design */}
      <section className="py-14">
        <div className="container">
          <div className="flex items-end justify-between mb-10">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-medium capitalize text-white mb-4">Entegrasyon Kategorileri</h2>
              <p className="text-sm text-default-200 font-medium">Çeşitli kategorilerdeki entegrasyon seçeneklerimizi keşfedin</p>
            </div>
          </div>

          {/* Category Tabs */}
          <div className="mb-12">
            <div className="flex flex-wrap justify-center gap-4 mb-8">
              {categories.map((category, index) => (
                <button
                  key={index}
                  onClick={() => setActiveCategory(index)}
                  className={`group relative px-6 py-4 rounded-xl transition-all duration-300 ${
                    activeCategory === index
                      ? 'bg-primary text-white shadow-lg shadow-primary/30'
                      : 'bg-default-950/60 text-default-300 hover:bg-default-950/80 hover:text-white border border-white/10'
                  }`}
                  data-aos="fade-up" 
                  data-aos-easing="ease" 
                  data-aos-duration="500"
                  data-aos-delay={index * 100}
                >
                  <div className="flex items-center gap-3">
                    <div className={`h-8 w-8 flex items-center justify-center rounded-lg transition-colors duration-300 ${
                      activeCategory === index
                        ? 'bg-white/20'
                        : 'bg-primary/20 text-primary group-hover:bg-primary/30'
                    }`}>
                      <i data-lucide={category.icon} className="h-5 w-5"></i>
                    </div>
                    <span className="font-medium">{category.title}</span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      activeCategory === index
                        ? 'bg-white/20 text-white'
                        : 'bg-primary/20 text-primary'
                    }`}>
                      {getCompaniesForCategory(category.id).length}
                    </span>
                  </div>
                  
                  {/* Active indicator */}
                  {activeCategory === index && (
                    <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-white rounded-full"></div>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Active Category Content */}
          <div className="relative">
            <div className="relative bg-default-950/60 backdrop-blur-sm rounded-2xl p-8 border border-white/10" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
             

              {/* Companies Grid */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {getCompaniesForCategory(categories[activeCategory]?.id).map((company, companyIndex) => (
                  <div 
                    key={companyIndex}
                    className="group p-6 rounded-xl bg-default-950/40 transition-all duration-500 hover:-translate-y-2 hover:bg-primary/40 border border-white/10"
                    data-aos="zoom-in" 
                    data-aos-easing="ease" 
                    data-aos-duration="600"
                    data-aos-delay={companyIndex * 100}
                  >
                    <div className="text-center">
                      {/* Logo Container */}
                      <div className="w-32 h-20 mx-auto bg-white rounded-lg flex items-center justify-center px-3 py-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img 
                          src={company.logo} 
                          alt={company.name} 
                          className="max-w-full max-h-full object-contain"
                          style={{ 
                            objectFit: 'contain',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            width: 'auto',
                            height: 'auto',
                            display: 'block',
                            margin: '0 auto'
                          }}
                        />
                      </div>
                      <h3 className="text-sm font-medium text-white mt-4">{company.name}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Integration Benefits */}
      <section className="py-14">
        <div className="container">
          <div className="flex items-end justify-between mb-10">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-medium capitalize text-white mb-4">Entegrasyon Avantajları</h2>
              <p className="text-sm text-default-200 font-medium">Sistem entegrasyonlarının size sağlayacağı faydalar</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8" data-aos="fade-right" data-aos-easing="ease" data-aos-duration="1000">
              <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-10">
                <i data-lucide="clock" className="h-10 w-10"></i>
              </div>
              <h2 className="text-2xl text-white font-medium mb-4">Zaman Tasarrufu</h2>
              <p className="text-base text-default-200 mb-6">
                Manuel işlemleri otomatikleştirerek zamanınızı daha değerli işlere ayırın. Entegrasyonlar sayesinde tekrarlayan görevler otomatik olarak gerçekleşir.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-sm text-default-300">
                  <i data-lucide="check" className="h-4 w-4 text-primary mr-2"></i>
                  Otomatik veri senkronizasyonu
                </li>
                <li className="flex items-center text-sm text-default-300">
                  <i data-lucide="check" className="h-4 w-4 text-primary mr-2"></i>
                  Manuel işlem azaltma
                </li>
                <li className="flex items-center text-sm text-default-300">
                  <i data-lucide="check" className="h-4 w-4 text-primary mr-2"></i>
                  Hızlı raporlama
                </li>
              </ul>
            </div>

            <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8" data-aos="fade-left" data-aos-easing="ease" data-aos-duration="1000">
              <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-10">
                <i data-lucide="shield-check" className="h-10 w-10"></i>
              </div>
              <h2 className="text-2xl text-white font-medium mb-4">Güvenilirlik</h2>
              <p className="text-base text-default-200 mb-6">
                Entegrasyonlarımız test edilmiş ve güvenilir sistemlerdir. Verilerinizin güvenliği ve sisteminizin stabilitesi bizim önceliğimizdir.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-sm text-default-300">
                  <i data-lucide="check" className="h-4 w-4 text-primary mr-2"></i>
                  Güvenli veri aktarımı
                </li>
                <li className="flex items-center text-sm text-default-300">
                  <i data-lucide="check" className="h-4 w-4 text-primary mr-2"></i>
                  Hata toleransı
                </li>
                <li className="flex items-center text-sm text-default-300">
                  <i data-lucide="check" className="h-4 w-4 text-primary mr-2"></i>
                  Yedekleme sistemi
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Custom Integration */}
      <section className="py-14">
        <div className="container">
          <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8 text-center" data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1000">
            <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-10 mx-auto">
              <i data-lucide="settings" className="h-10 w-10"></i>
            </div>
            <h2 className="text-2xl text-white font-medium mb-4">Özel Entegrasyon</h2>
            <p className="text-base text-default-200 mb-6 max-w-2xl mx-auto">
              Mevcut entegrasyonlarımız ihtiyaçlarınızı karşılamıyor mu? Özel entegrasyon geliştirme hizmetimiz ile sisteminizi tamamen uyumlu hale getirebiliriz.
            </p>
            <Link 
              to="/iletisim" 
              className="inline-flex items-center justify-center gap-2 bg-primary text-white py-2 px-6 rounded-full hover:bg-primary-hover transition-all duration-300"
            >
              Özel Entegrasyon Talebi
              <i data-lucide="arrow-right" className="h-5 w-5"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Entegrasyonlar;
